import React from 'react';
import { Sparkles } from 'lucide-react';
interface MatchContextProps {
  visible: boolean;
}
export function MatchContext({
  visible
}: MatchContextProps) {
  if (!visible) return null;
  return <section className="px-6 md:px-12 max-w-6xl mx-auto mt-6 mb-8 relative z-20" data-id="element-92">
      <div className="bg-brand-forest/10 border border-brand-forest/20 rounded-2xl px-6 py-5" data-id="element-93">
        <div className="flex items-start gap-3" data-id="element-94">
          <div className="w-8 h-8 rounded-full bg-brand-forest/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-95">
            <Sparkles size={16} className="text-brand-forest" data-id="element-96" />
          </div>
          <div data-id="element-97">
            <p className="text-sm font-medium text-brand-dark mb-1" data-id="element-98">
              Why you were matched
            </p>
            <p className="text-sm text-brand-muted leading-relaxed" data-id="element-99">
              Marcus has closed{' '}
              <span className="font-mono text-brand-dark" data-id="element-100">28 homes</span> in
              your ZIP (94109) at{' '}
              <span className="font-mono text-brand-dark" data-id="element-101">
                5.2% above market
              </span>
              , with an average of{' '}
              <span className="font-mono text-brand-dark" data-id="element-102">18 days</span> on
              market — 12 days faster than the local median. His price range
              sweet spot (
              <span className="font-mono text-brand-dark" data-id="element-103">$425K–$2.5M</span>)
              aligns with your estimated home value.
            </p>
          </div>
        </div>
      </div>
    </section>;
}